module.exports = __webpack_public_path__ + "img/tsonev.d11dc17d.jpg";